export enum SignInButton {
    CLICKED = 'Sign In Button Clicked',
}

export enum CTA {
    CLICKED = 'CTA Clicked',
    BOOK_DEMO_CLICKED = 'CTA Book Demo Clicked',
}

export enum Customer {
    DETECTED = 'Detected As Customer',
}

export enum HeaderNavigation {
    CLICKED_NAVIGATION_LINK = 'Clicked Top Navigation Link',
}

export enum Examples {
    MODAL_OPENED = 'Example Modal Opened',
    MODAL_CLOSED = 'Example Modal Closed',
}

export enum StoryFile {
    DOWNLOAD = 'Story File Download',
}

export enum StoryGalleryImage {
    DOWNLOAD = 'Gallery Image Download',
    VIEW = 'Gallery Image View',
}

export enum StoryLink {
    CLICK = 'Story Link Click',
}

export enum CalendlyEvents {
    DATE_AND_TIME_SELECTED = 'Calendly Date And Time Selected',
    SCHEDULED = 'Calendly Scheduled',
}

export enum FaqEvents {
    OPENED = 'FAQ Item Opened',
    CLOSED = 'FAQ Item Closed',
}
